import React from "react";
import { Avatar, Button, Card, Col, Row, Space, Typography, Dropdown } from "antd";
import { UserOutlined, MoreOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
const { Title, Text } = Typography;

// Rendered inside `.clients-page` (Clients.jsx); styles live in Clients.css.
const ClientsGridView = ({ data }) => {
  const { t } = useTranslation("dashboard");
  const history = useHistory();

  const menuItems = [
    { key: "1", label: t("Action 1") },
    { key: "2", label: t("Action 2") }
  ];

  return (
    <Row gutter={[16, 16]}>
      {data.map((client, index) => (
        <Col xs={24} sm={12} md={8} lg={6} key={client?._id ?? index}>
          <Card
            className="clients-grid__card"
            cover={
              <div className="clients-grid__cover">
                <div className="clients-grid__menu">
                  <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
                    <Button type="text" icon={<MoreOutlined />} aria-label={t("Actions")} />
                  </Dropdown>
                </div>
                {client.picture ? (
                  <Avatar size={96} src={Object.values(client.picture)[0]} />
                ) : (
                  <Avatar size={96} icon={<UserOutlined />} />
                )}
              </div>
            }
          >
            <Card.Meta
              title={
                <Title level={4} className="clients-grid__text">
                  {client.firstName}
                </Title>
              }
              description={
                <Space direction="vertical" size={4}>
                  <Text type="secondary" className="clients-grid__text">
                    {client.email}
                  </Text>
                  <Text type="secondary">{t("CEO")}</Text>
                </Space>
              }
            />
            <div className="clients-grid__actions">
              <Button type="primary">{t("Message")}</Button>
              <Button
                type="primary"
                onClick={() => history.push(`/user/clients/projects/${client._id}`)}
              >
                {t("View Profile")}
              </Button>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ClientsGridView;
